import { gql } from '@apollo/client';

export const UNBLOCK_USER = gql`
  mutation UnblockUser($userId: ID!) {
    unblockUser(userId: $userId) {
      entity
      errors {
        message
      }
    }
  }
`;

export const LOGIN_USER = gql`
  mutation LoginUser($accessToken: String!) {
    loginUser(accessToken: $accessToken) {
      entity
      errors {
        message
      }
    }
  }
`;

export const LOGOUT_USER = gql`
  mutation LogoutUser {
    logoutUser {
      entity
      errors {
        message
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($userParams: UpdateUserAttributes!) {
    updateUser(userParams: $userParams) {
      entity {
        id
        legacyId
        name
        email
        emailConfirmed
      }
      errors {
        message
        path
      }
    }
  }
`;
